import React, { useState, useEffect } from 'react';
import { achievementsData } from '../../data/achievementsData';
import { useScrollAnimation } from '../hooks/ScrollAnimation';
import { useTheme } from '../../context/ThemeContext';

const Counter = ({ target, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(target.replace(/\D/g, ""), 10);
    if (start === end) return;
    const incrementTime = parseInt(duration) / end;
    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);
    return () => clearInterval(timer);
  }, [target, duration]);

  return <span>{count}{target.includes("+") && "+"}</span>;
};

const AchievementsSection = () => {
  const { isDark } = useTheme();
  const { ref: statsRef, isVisible: statsVisible } = useScrollAnimation({ threshold: 0.1, repeat: true });

  const achievementsList = isDark
    ? [
        { label: "Projects",   value: achievementsData.projects,     bg: "bg-blue-900/30 hover:bg-blue-900/50",     dot: "bg-blue-500",   text: "text-blue-400"   },
        { label: "Pengalaman", value: achievementsData.experience,   bg: "bg-purple-900/30 hover:bg-purple-900/50", dot: "bg-purple-500", text: "text-purple-400" },
        { label: "Teknologi",  value: achievementsData.technologies, bg: "bg-green-900/30 hover:bg-green-900/50",   dot: "bg-green-500",  text: "text-green-400"  },
        { label: "Sertifikat", value: achievementsData.certificates, bg: "bg-red-900/30 hover:bg-red-900/50",       dot: "bg-red-500",    text: "text-red-400"    },
      ]
    : [
        { label: "Projects",   value: achievementsData.projects,     bg: "bg-blue-50 hover:bg-blue-100",     dot: "bg-blue-500",   text: "text-blue-600"   },
        { label: "Pengalaman", value: achievementsData.experience,   bg: "bg-purple-50 hover:bg-purple-100", dot: "bg-purple-500", text: "text-purple-600" },
        { label: "Teknologi",  value: achievementsData.technologies, bg: "bg-green-50 hover:bg-green-100",   dot: "bg-green-500",  text: "text-green-600"  },
        { label: "Sertifikat", value: achievementsData.certificates, bg: "bg-red-50 hover:bg-red-100",       dot: "bg-red-500",    text: "text-red-600"    },
      ];

  const cardBg = isDark ? 'bg-[#111C2C]' : 'bg-white';
  const titleColor = isDark ? 'text-white' : 'text-gray-800';
  const dividerColor = isDark ? 'border-[#1E3A5F]' : 'border-gray-200';
  const labelColor = isDark ? 'text-slate-400' : 'text-gray-700';

  return (
    <div
      ref={statsRef}
      className={`${cardBg} pixel-border p-5 w-full max-w-xs shadow-lg`}
      style={{
        opacity: statsVisible ? 1 : 0,
        transform: statsVisible ? 'translateX(0)' : 'translateX(-24px)',
        transition: 'opacity 0.6s ease-out 0.1s, transform 0.6s ease-out 0.1s',
      }}
    >
      <h4 className={`text-sm font-semibold ${titleColor} mb-4 pixel-font text-center border-b ${dividerColor} pb-2`}>
        ACHIEVEMENT
      </h4>
      <div className="space-y-3">
        {achievementsList.map((item, i) => (
          <div key={i} className={`flex items-center justify-between p-2 ${item.bg} pixel-border transition-colors`}>
            <div className="flex items-center">
              <div className={`w-3 h-3 ${item.dot} mr-2`} />
              <span className={`text-xs ${labelColor}`}>{item.label}</span>
            </div>
            <span className={`text-lg font-bold ${item.text} pixel-font`}>
              <Counter target={`${item.value}+`} />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AchievementsSection;
